import React from "react";
import CriteriaCard from "./CriteriaCard";
import type { DispositionEvidence, DispositionOption } from "./types";

type Props = {
  option: DispositionOption | undefined;
  onEvidenceClick?: (evidence: DispositionEvidence) => void;
};

const DispositionOptionContent: React.FC<Props> = ({
  option,
  onEvidenceClick,
}) => {
  if (!option) {
    return (
      <p className="text-sm text-gray-500">
        No disposition option selected.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <section>
        <div className="flex items-center gap-1.5">
          <h2 className="text-sm font-bold uppercase tracking-widest text-black">
            Rationale
          </h2>
          <img
            src="/ai-bulwark-logo.svg"
            alt=""
            aria-hidden
            className="h-3.5 w-auto shrink-0 object-contain"
          />
        </div>
        <p className="mt-2 text-sm leading-relaxed text-gray-700">
          {option.summary}
        </p>
      </section>

      <section className="flex flex-col gap-2.5">
        {(option.criteria ?? []).map((criterion) => (
          <CriteriaCard
            key={criterion.name}
            criterion={criterion}
            onEvidenceClick={onEvidenceClick}
          />
        ))}
      </section>
    </div>
  );
};

export default DispositionOptionContent;
